var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"d-flex"},[_c('h6',{staticClass:"mr-auto"},[_vm._v(_vm._s(_vm.vendor.gli))]),(_vm.vendor.created)?_c('div',{staticClass:"font-italic text-muted"},[_vm._v(_vm._s(_vm._f("timediff")(_vm.vendor.created)))]):_vm._e()]),_c('div',[_vm._v(_vm._s(_vm.vendor.company))])])
}
var staticRenderFns = []

export { render, staticRenderFns }